<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { ENTITIES } from '@/lib/entities.js'
import { useUi } from '@/stores/ui.js'

/**
 * A reference to a record (a related record, a field's value, a mention): a click opens the
 * record in a panel from the right, over what is on screen; Ctrl/⌘ or Shift with the click, or
 * the middle button, opens its full page in a new tab, as any link. An offer opens in its editor.
 */
const props = defineProps({ entity: { type: String, default: '' }, uuid: { type: String, default: '' } })
const router = useRouter()
const ui = useUi()
const target = computed(() => (props.entity === 'offer'
  ? { name: 'offer-editor', params: { uuid: props.uuid } }
  : { name: 'record', params: { entityPath: ENTITIES[props.entity]?.path || props.entity, uuid: props.uuid } }))
// Of no kind or no record (a reference not read yet): its words alone, no link to nowhere.
const linked = computed(() => !!props.entity && !!props.uuid)
const href = computed(() => (linked.value ? router.resolve(target.value).href : null))

function open(e) {
  if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return
  e.preventDefault()
  if (props.entity === 'offer' || !ENTITIES[props.entity]) router.push(target.value)
  else ui.openRecord({ entity: props.entity, uuid: props.uuid })
}
</script>

<template>
  <a v-if="linked" v-private :href="href" @click="open"><slot /></a>
  <span v-else v-private><slot /></span>
</template>
